export const en = {
  nav: {
    home: "Home",
    products: "Products",
    about: "About",
    blog: "Blog",
    contact: "Contact",
    homeSub: "Start here",
    productsSub: "What we build",
    aboutSub: "Who we are",
    blogSub: "Ideas & essays",
    contactSub: "Get in touch",
  },
  common: {
    menu: "Menu",
    close: "Close",
    studio: "Technology studio",
    madeInBrazil: "Made in Brazil",
    builtInBrazil: "Built in Brazil",
    exploreProducts: "Explore products",
    getInTouch: "Get in touch",
    skipToContent: "Skip to content",
  },
  hero: {
    line1: "Technology",
    line2: "for people",
    sub: "We build software & tools that help people: social, educational, and beyond.",
  },
  features: {
    eyebrow: "What we stand for",
    line1: "Built to",
    line2: "help",
    sub: "Social, educational, or everyday: whatever we build has to genuinely help. That's the only test that matters.",
    items: [
      {
        title: "Useful, not just clever",
        desc: "Every tool has to earn its place by making something real easier. If it doesn't genuinely help a person, we don't ship it.",
      },
      {
        title: "Privacy by default",
        desc: "People trust us with their time and their data. Minimal collection, encrypted by default, LGPD from day one, no surprises.",
      },
      {
        title: "Open & honest",
        desc: "Public priorities, honest timelines, and clear criteria. You always know what we're building and why.",
      },
    ],
  },
  marquee: [
    "Technology for people",
    "Education",
    "Community",
    "Accessibility",
    "Privacy by default",
    "Human-centered",
    "Social impact",
    "Open & honest",
    "Built in Brazil",
    "Less, but better",
  ],
  cta: {
    eyebrow: "The next step",
    heading: "Have something in mind",
    sub: "Social, educational, or something new: if it helps people, we'd love to hear about it.",
    talkToUs: "Talk to us",
    seeProducts: "See products",
  },
  footer: {
    lede: "Software & tools that help people: social, educational, and everyday. Built in Brazil, for everyone.",
    index: "Index",
    backToTop: "Back to top",
    copyright: "© {{year}} Avoria. Built in Brazil.",
    privacy: "Privacy",
    faq: "FAQ",
  },
  about: {
    eyebrow: "Philosophy",
    side: "Who we are",
    title: "The philosophy behind Avoria",
    sub: "Avoria exists for one reason: to build software and tools that genuinely help people in how they learn, connect, and live. Without rush, but with purpose.",
    manifestoLabel: "( The Manifesto )",
    manifesto: [
      "We build to help people, first and always.",
      "We connect the parts, so the whole makes sense.",
      "We protect people, so trust can exist.",
    ],
    manifestoFoot: "Avoria Manifesto. Help first, with clarity and purpose.",
    nameLabel: "( The Name )",
    nameTitle: 'Why the name "Avoria"?',
    namePara1:
      "Avoria is a synthesis of <aurora>aurora</aurora> (the dawn of a new cycle) and <avorio>avorio</avorio> (ivory, purity and resilience). It represents the point where the rational and the aesthetic meet: technology with soul, engineering with ethics.",
    namePara2:
      "Just as the aurora announces the day, Avoria wants to be a beginning: a new way of building software, centered on people, clarity, and purpose.",
    philTitle: "Our philosophy",
    philSub: "Five things we hold true.",
    pillars: [
      {
        title: "People first",
        desc: "We build software and tools to genuinely help people in education, community, and everyday life. That comes before anything else.",
      },
      {
        title: "Less, but better",
        desc: "Few things, done impeccably. Every line of code must justify its existence.",
      },
      {
        title: "Radical transparency",
        desc: "Public roadmaps, open metrics, and honest communication. Trust is born from clarity.",
      },
      {
        title: "Technology with soul",
        desc: "Experiences that care for people: beautiful, accessible, and respectful by default.",
      },
      {
        title: "Built in LatAm, made for everyone",
        desc: "We start from Latin America, turning constraints into creativity, and build for people everywhere.",
      },
    ],
    futureLabel: "( The Future )",
    futureTitle: "Our vision for the future",
    futurePara1:
      "Avoria was born to last. We don't seek to grow fast, but to grow right: a family of tools that each help people in a real, lasting way, connected by clarity and purpose.",
    futurePara2:
      "In the long run, we want Avoria to be a name people trust: wherever there's something worth making easier (learning, connecting, living), there's an Avoria tool for it.",
  },
  products: {
    eyebrow: "Products",
    side: "Our first product",
    title: "Learn by doing, not just reading",
    sub: "We build tools that make complex technical topics accessible, interactive, and genuinely fun to learn.",
    linkoLabel: "Interactive Learning",
    linkoDesc:
      "Interactive platform for learning Networking and Telecom. Hands-on labs, visual simulations, and guided challenges that turn abstract protocols into tangible skills.",
    joinWaitlist: "Join the waitlist",
    requestDemo: "Request a demo",
    highlights: [
      { title: "Network simulations", desc: "Build and troubleshoot real topologies in the browser." },
      { title: "Gamified challenges", desc: "Progress through levels, earn badges, compete with peers." },
      { title: "Guided curriculum", desc: "From OSI model basics to advanced routing protocols." },
      { title: "Cert-ready", desc: "Content aligned with CCNA, CompTIA Network+, and more." },
    ],
    whyLinko: "Why Linko",
    philosophyLabel: "Philosophy",
    philTitle: "Learn protocols, not just theory",
    philDesc:
      "Traditional courses teach you what a packet is. Linko lets you watch it travel, break it, fix it, and understand why it matters. Interactive-first, theory-second.",
    builtByLabel: "Built by Avoria",
    qualityTitle: "Quality over quantity",
    qualityDesc:
      "Every lab is handcrafted, every simulation tested. We don't rush content. We ship what actually helps you learn and retain knowledge for the long term.",
  },
  blog: {
    eyebrow: "Journal",
    essays: "{{count}} essays",
    line1: "Ideas that",
    line2: "shape the essential",
    sub: "Reflections, insights, and experiments on technology, philosophy, and an ethical digital future.",
    featured: "Featured",
    readArticle: "Read article",
    read: "Read",
    more: "More from the journal",
  },
  blogPost: {
    backToBlog: "Back to blog",
    notFoundLabel: "Error 404",
    notFoundTitle1: "Post not",
    notFoundTitle2: "found",
    notFoundSub: 'The post "{{slug}}" doesn\'t exist or has been moved.',
    theEssay: "The essay",
  },
  notFound: {
    label: "Error 404",
    side: "Page not found",
    subPrefix: "We looked everywhere for",
    subSuffix: ", but this page doesn't exist.",
    back: "Back to home",
    contactPrefix: "If you think this is an error, please",
    contactLink: "contact the Avoria team",
  },
  contact: {
    eyebrow: "Contact",
    title1: "Let's",
    title2: "build",
    sub: "Tell us about your company and what you need. We respond quickly, with clarity and objectivity.",
    formLabel: "01 / Send a message",
    nameLabel: "Name",
    namePlaceholder: "Your name",
    emailLabel: "Email",
    emailPlaceholder: "you@company.com",
    companyLabel: "Company",
    companyPlaceholder: "Company name",
    topicLabel: "Topic",
    topicLinko: "Linko (interactive learning)",
    topicPartnership: "Partnerships",
    topicSupport: "Support",
    topicOther: "Other",
    messageLabel: "Message",
    messagePlaceholder: "Briefly describe your context, goals, and timeline.",
    consentPre: "I agree to be contacted by Avoria and accept the",
    privacyPolicy: "Privacy Policy",
    sending: "Sending...",
    send: "Send message",
    sendEmail: "Send email",
    responseNote: "We usually respond within 1-2 business days.",
    otherLabel: "02 / Other channels",
    otherTitle1: "Prefer to reach",
    otherTitle2: "out directly",
    emailChannel: "Email",
    questionsChannel: "Questions",
    faq: "Frequently asked questions",
    asideNote: "We only keep what's essential. No spam. You can request data removal at any time.",
    validation: {
      nameRequired: "Please enter your name.",
      emailInvalid: "Please enter a valid email.",
      messageRequired: "Please write a message.",
      consentRequired: "You must accept the contact policy.",
      sendFailed: "Unable to send.",
    },
    toastSuccess: "Message sent! We'll get back to you soon.",
    toastError: "Could not send right now. Please try again.",
  },
  seo: {
    home: {
      title: "Avoria | Technology for people",
      desc: "Avoria builds software and tools that help people: social, educational, and beyond. Built in Brazil, for everyone.",
    },
    about: {
      title: "About | Avoria",
      desc: "The philosophy behind Avoria: building software and tools that genuinely help people, with clarity, ethics, and purpose.",
    },
    products: {
      title: "Products | Avoria",
      desc: "Linko, our first product: interactive, hands-on learning for networking and telecom. Learn by doing, not just reading.",
    },
    blog: {
      title: "Blog | Avoria",
      desc: "Ideas, insights, and experiments on technology, philosophy, and an ethical digital future, from the Avoria team.",
    },
    contact: {
      title: "Contact | Avoria",
      desc: "Tell us about your project. Social, educational, or something new: if it helps people, we'd love to hear from you.",
    },
    notFound: {
      title: "Page not found | Avoria",
      desc: "The page you're looking for doesn't exist. Head back to Avoria's homepage.",
    },
  },
  privacy: {
    metaTitle: "Privacy Policy | Avoria",
    metaDesc: "How Avoria collects, uses, and protects your data. Privacy by default, aligned with the LGPD.",
    eyebrow: "Legal",
    title: "Privacy Policy",
    updated: "Last updated: June 2026",
    intro: "Privacy is one of Avoria's core values, not an afterthought. This page explains, in plain language, what we collect and why.",
    sections: [
      { h: "What we collect", p: "Only the minimum we need: the details you send through the contact form (name, email, company, topic, and message) and privacy-friendly, aggregated analytics with no cookies and no personal profiling." },
      { h: "Why we collect it", p: "To reply to you (based on your consent) and to understand, in aggregate, how the site is used (legitimate interest). Nothing more." },
      { h: "How long we keep it", p: "Contact messages are kept only as long as needed to handle your request, then deleted. Aggregated analytics contain no personal data." },
      { h: "Your rights (LGPD)", p: "You can request access, correction, or deletion of your data at any time by emailing contact@avoria.com. We respond within a reasonable time." },
      { h: "Security", p: "Minimal collection, encryption in transit, and access on a need-to-know basis. Privacy by default is one of our founding principles." },
      { h: "Third parties", p: "We never sell your data. We use a cookieless analytics provider and standard infrastructure providers, all bound to protect your information." },
      { h: "Changes", p: "If this policy changes, we will update this page and the date above." },
    ],
  },
  faq: {
    metaTitle: "FAQ | Avoria",
    metaDesc: "Answers about Avoria, Linko, privacy, languages, and how to get in touch.",
    eyebrow: "Help",
    title: "Frequently asked questions",
    sub: "Short, honest answers. Still curious? Just reach out.",
    items: [
      { q: "What is Avoria?", a: "Avoria is a technology studio that builds software and tools to help people, across social, educational, and everyday contexts. Linko is our first product." },
      { q: "What is Linko?", a: "Linko is an interactive, hands-on platform for learning networking and telecom: labs, visual simulations, and guided challenges. You learn by doing, not just reading." },
      { q: "When does Linko launch?", a: "We're building it carefully and in public. Join the waitlist from the Products page to be the first to know." },
      { q: "How do you handle my data?", a: "Privacy by default: we collect the minimum, never sell your data, and use cookieless analytics. See our Privacy Policy for the details." },
      { q: "Can I request that my data be deleted?", a: "Yes. Email contact@avoria.com and we'll remove your data. It's your right under the LGPD." },
      { q: "Which languages is the site available in?", a: "English and Brazilian Portuguese. Use the EN / PT switcher in the header." },
      { q: "How can I work with or contact Avoria?", a: "Use the contact form or email contact@avoria.com. We usually respond within 1-2 business days." },
    ],
  },
};

export type TranslationResources = typeof en;
